import React, { Component } from "react";
import { CircularProgress, Icon, withStyles } from "@material-ui/core";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { compose } from "redux";
import ListComponent from "../Common/ListComponent";

class ContactProfileRight extends Component {
  state = {
    attachment: null,
    activedatas: [],
    updatelistorder: true,
    isDataLoading: true,
    userSelectedEmail: '',
    Username: '',
  };

  componentWillUnmount() {
    this.props.contactReducer.contactFieldData = [];
  }

  componentWillMount() {
    let val = { recordtypeid: 2 }
    this.props.getRelatedMasterList(this.props.apolloClient.client, val);
    this.props.getUserIntegration(this.props.apolloClient.client);

    if (this.props.contact_id) {
      this.props.getContactField(this.props.apolloClient.client, this.props.contact_id);
      this.setState({
        contact_id: this.props.contact_id,
      }, () => {
        this.forceUpdate()
      });
    }

  }
  componentWillReceiveProps(props) {
    if (props.contact_id != this.state.contact_id) {
      this.setState({
        contact_id: parseInt(props.contact_id),
      }, () => {
        this.forceUpdate()
      });
    }
    if (props.contactReducer.contactFieldData.data) {
      const contactDataForEdit = props.contactReducer.contactFieldData.data;
      contactDataForEdit.map((v, i) => {
        if (v.contactdetail.length > 0 && v.contactdetail[0].values.length > 0) {
          if (v.fieldkey == "email") {
            this.setState({
              userSelectedEmail: v.contactdetail[0].values[0].value,
            })
          }
        }
        if (v.fieldkey == "name") {
          this.setState({
            Username: v.contactdetail[0].fieldvalue,
          })
        }
        // }
      })
    }
    if (props.settingReducer.userItegration.data && props.settingReducer.userItegration.data !== this.state.itegrationDetails) {
      let data = props.settingReducer.userItegration.data;
      let hasRingCentralConnect = false;
      data.map((item) => {
        if (item.status && item.integrationid == 10) {
          hasRingCentralConnect = true;
          console.log('Contact details Page');
          var rcs = document.createElement("script");
          rcs.src = "/https://ringcentral.github.io/ringcentral-embeddable/adapter.js?&disableGlip=true&disableConferenceCall=true&disableMessages=true&clientId=hPpoApgkSt2Hy1VZqUrrhQ";
          var rcs0 = document.getElementsByTagName("script")[0];
          rcs0.parentNode.insertBefore(rcs, rcs0);
          if (window.RCAdapter) {
            window.RCAdapter.setMinimized(false);
            window.RCAdapter.setClosed(false);
          }
          window.addEventListener('message', (e) => {
            const data = e.data;
            if (data) {
              switch (data.type) {
                case 'rc-call-start-notify':
                  console.log("web START calll", data.call);
                  break;
                case 'rc-call-end-notify':
                  console.log("web END call", data.call);
                  this.setState({ ringCentralData: data.call }, () => this.UpdateSettingRingCentral());
                  break;
                case 'rc-active-call-notify':
                  console.log("web Active Call", data.call);
                  break;
                default:
                  break;
              }
            }
          });
        }
      });
      this.setState({
        itegrationDetails: data,
        hasRingCentralConnect: hasRingCentralConnect,
      });
    }
    if (props.settingReducer.contactrelatedMaster.data) {
      const contactrelatedMaster = props.settingReducer.contactrelatedMaster.data;
      let activedatas = [];

      contactrelatedMaster.map((fieldData, index) => {
        if (fieldData.isactive === true) {
          activedatas.push({
            key: fieldData.id,
            alias: fieldData.alias,
            isactive: fieldData.isactive,
            orderid: fieldData.orderno,
          });
        }
      });
      if (this.state.updatelistorder == true) {
        this.setState({ activedatas: activedatas, isDataLoading: false }, () => this.forceUpdate());
      }
    }
  }
  UpdateSettingRingCentral = () => {
    let data = [];
    if (this.state.ringCentralData.direction === "Outbound") {
      data['data'] = {
        direction: this.state.ringCentralData.direction,
        telephonyStatus: this.state.ringCentralData.callStatus,
        fromphoneNumber: this.state.ringCentralData.fromNumber,
        fromName: this.state.Username,
        phoneNumber: this.state.ringCentralData.to,
        startTime: this.state.ringCentralData.startTime
      };
      console.log(data['data'], "jhsbdjbcjs");
      let req = {
        text: JSON.stringify(data['data']),
        sourcetype: 2,
        sourceid: parseInt(this.state.contact_id),
      }
      console.log(req, 'UpdateSettingRingCentral');
      this.props.saveRingCentralData(this.props.apolloClient.client, req);
    }
  }

  render() {
    return (
      <>
        {this.state.isDataLoading ?
          <CircularProgress size={25} disableShrink className="loaderPopupCenter" />
          :
          this.state.contact_id &&
          <ListComponent
            recordId={this.state.contact_id}
            userSelectedEmail={this.state.userSelectedEmail}
            Username={this.state.Username}
            recordtype={"contact"}
            activedata={this.state.activedatas}
            relate
            allData={this}
          />}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    contactReducer: state.contactReducer,
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getRelatedMasterList: (client, request) => { dispatch(actions.getRelatedMasterList(client, request)); },
    getContactField: (client, contact_id) => dispatch(actions.getContactField(client, contact_id)),
    getUserIntegration: (client) => dispatch(actions.getUserIntegration(client)),
    saveRingCentralData: (client, value) => dispatch(actions.saveRingCentralData(client, value)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ContactProfileRight);